import { unwrap } from "@nexxt/api-client";
import type { BellClient } from "@nexxt/app-kit";
import { api } from "./api";
import { linkOf } from "./bell-links";

// The bell on its gateway (ADR-280): the three routes, the page of each item from `bell-links.ts`, and the pushes of
// this device (ADR-283).

const { inbox, push } = api.notifications;

export const bellClient: BellClient = {
  list: (cursor) => unwrap(inbox.$get({ query: cursor ? { cursor } : {} })),
  unread: () => unwrap(inbox.unread.$get()),
  markRead: (json) => unwrap(inbox.read.$post({ json })),
  linkOf,
  push: {
    settings: () => unwrap(push.$get()),
    subscribe: (json) => unwrap(push.subscription.$put({ json })),
    unsubscribe: (json) => unwrap(push.subscription.$delete({ json })),
  },
};
